import { useQuery } from '@tanstack/react-query';
import { fetchSite } from '@/app/Sites/siteApi';

export const useSiteData = (projectId: string | undefined, companyId: string | undefined) => {
  return useQuery({
    queryKey: ['site-data', projectId, companyId],
    queryFn: async () => {
      if (!projectId || !companyId) {
        throw new Error('Project ID and Company ID are required');
      }
      return fetchSite(projectId, companyId);
    },
    enabled: !!projectId && !!companyId,
  });
};
